import { useNavigate } from "react-router";
import { useCustomDispatch } from "../../../hooks/redux";
import {
  IPausarIniciarTarea,
  IRespuestPausarExcedida,
  ITareaTomarLiberarPost,
} from "../../../interfaces/backendApi/tareaTomarLiberar";
import { setBackendItemTareaCatalogo } from "../../../redux/slices/backend/itemTareaCatalogo";
import { setBackendClearTareaResolver } from "../../../redux/slices/backend/tareaResolver";
import {
  setBackendClearTareaTomarLiberar,
  setBackendTareaTomarLiberar,
} from "../../../redux/slices/backend/tareaTomarLiberar";
import { useCallback, useState } from "react";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import {
  setBackendCategoriaPorId,
  setBackendClearCategoriaPorId,
} from "../../../redux/slices/backend/categoriaPorId";
import { iItemCategoriaPorId } from "../../../interfaces/backendApi/itemCategoriaPorId";
import { setBackendComentariosCasoActivo } from "../../../redux/slices/backend/comentariosCasoActivo";
import { paramCaseId, paramTarea } from "../../helper/customUseURLSearchParams";
import {
  setBackendClearReiniciarTarea,
  setBackendReiniciarTarea,
} from "../../../redux/slices/backend/reiniciarTarea";
import { setBackendObtenerTiposPausa } from "../../../redux/slices/backend/obtenerTiposPausa";
import {
  setBackendClearPausarTarea,
  setBackendPausarTarea,
} from "../../../redux/slices/backend/pausarTarea";
import { setBackendListaTareasRecurso } from "../../../redux/slices/backend/listaTareasRecurso";
import { setBackendListaTareasTomadasRecurso } from "../../../redux/slices/backend/listaTareasTomadasRecurso";
import {
  setClearRespuestaPausaExcedida,
  setRespuestaPausaExcedida,
} from "../../../redux/slices/backend/respuestaPausaExcedida";
import { setBackendObtenerGuardia } from "../../../redux/slices/backend/obtenerGuardia";
import { selectStoreUsuarioActivo } from "../../../redux/helpers/selectStore";
import { setBackendObtenerGuardiaRealizada } from "../../../redux/slices/backend/obtenerGuardiaRealizada";
import { setBackendObtenerGuardiaCancelada } from "../../../redux/slices/backend/obtenerGuardiaCancelada";
import { setBackendTicketModificar } from "../../../redux/slices/backend/ticketModificar";
import {
  Issue,
  ITicketModificarPost,
} from "../../../interfaces/backendApi/ticketModificar";
import { setBackendPausaDiaria } from "../../../redux/slices/backend/obtenerPausaDiaria";
import {
  setBackendClearObtenerEstadoUsuario,
  setBackendObtenerEstadoUsuario,
} from "../../../redux/slices/backend/obtenerEstadoUsuario";
import { setBackendActualizarDisponibilidad } from "../../../redux/slices/backend/actualizarDisponibilidad";

export const useHandle = () => {
  const dispatchs = useCustomDispatch();
  const objUsuarioStore = selectStoreUsuarioActivo();
  let idCase = paramCaseId();
  let idTask = paramTarea();

  const navigate = useNavigate();
  const navigateTo = (routeUrl: string) => {
    navigate(routeUrl);
  };
  const INTEVALO_MODAL_Ok = Number(process.env.REACT_APP_INTEVALO_MODAL_Ok);

  function redirectTask(url: string) {
    return setTimeout(function () {
      navigateTo(url);
    }, INTEVALO_MODAL_Ok);
  }
  function redirectCase(url: string) {
    return setTimeout(function () {
      navigateTo(url);
    }, 1);
  }
  function refreshPage() {
    return setTimeout(function () {
      window.location.reload();
    }, INTEVALO_MODAL_Ok);
  }

  const handleLimpiarStatus = useCallback(async (): Promise<void> => {
    await handleBackendClearTareaTomarLiberar();
  }, [dispatchs]);

  const handleDisponible = async (
    disponible: boolean,
    disponibleGuardia: boolean,
  ) => {
    await dispatchs(
      setBackendActualizarDisponibilidad(disponible, disponibleGuardia),
    );
  };
  const handleBackendObtenerEstadoUsuario = async () => {
    await dispatchs(setBackendObtenerEstadoUsuario());
  };
  const handleBackendClearObtenerEstadoUsuario = async () => {
    await dispatchs(setBackendClearObtenerEstadoUsuario());
  };

  const handleBackendTareaTomarLiberar = async (
    tareaTomarLiberarPost: ITareaTomarLiberarPost,
  ) => {
    await dispatchs(setBackendTareaTomarLiberar(tareaTomarLiberarPost));
  };

  const handleBackendClearTareaResolver = async () => {
    await dispatchs(setBackendClearTareaResolver());
  };
  const handleBackendClearTareaTomarLiberar = async () => {
    await dispatchs(setBackendClearTareaTomarLiberar());
  };
  const handleBackendComentariosCasoActivo = async (caseId: string) => {
    await dispatchs(setBackendComentariosCasoActivo(Number(caseId)));
  };
  let [fechaHora, setFechaHora] = useState(new Date());

  const { categoriaPorId } = useSelector(
    (store: RootState) => store.itemCategoriaPorId,
  );
  const [categoriaId, setCategoriaPorId] =
    useState<iItemCategoriaPorId[]>(categoriaPorId);

  const handleCategoriaDescripcion = async (IdCategoria: number) => {
    await dispatchs(setBackendCategoriaPorId(IdCategoria));
    setCategoriaPorId(categoriaPorId);
  };
  const handleBackendClearCategoriaPorId = async () => {
    await dispatchs(setBackendClearCategoriaPorId());
  };
  const handleBackendItemTareaCatalogo = async (
    tiempoEstim_ref: string,
    categoria: string,
  ) => {
    await dispatchs(setBackendItemTareaCatalogo(Number(categoria)));
  };

  const handeAddCommentBackend = async (caseId: string, comments: string) => {
    const issue: Issue = {
      issue_id: Number(caseId),
      notes: comments,
      status_id: 0,
    };
    const ticketModificarPost: ITicketModificarPost = {
      issue: issue,
    };
    await dispatchs(setBackendTicketModificar(ticketModificarPost));
    return;
  };

  const handleBackendObtenerTiposPausa = async (DisplayName: string) => {
    await dispatchs(setBackendObtenerTiposPausa(DisplayName));
  };
  const handlePausaDiaria = async () => {
    await dispatchs(setBackendPausaDiaria());
  };

  const handleBackendReiniciarTarea = async (data: IPausarIniciarTarea) => {
    await dispatchs(
      setBackendReiniciarTarea(
        data.id,
        data.caseId,
        data.state,
        data.type,
        data.executedBy,
        data.description,
      ),
    );
  };

  const handleBackendPausarTarea = async (data: IPausarIniciarTarea) => {
    await dispatchs(
      setBackendPausarTarea(
        data.id,
        data.caseId,
        data.state,
        data.type,
        data.executedBy,
        data.description,
        data.displayName,
      ),
    );
  };
  const handleRespuestaPausaExcedida = async (
    data: IRespuestPausarExcedida,
  ) => {
    await dispatchs(
      setRespuestaPausaExcedida(
        Number(data.IdTarea),
        Number(data.Caso),
        data.Estado,
        1,
      ),
    );
  };

  const handleClearRespuestaPausaExcedida = async () => {
    await dispatchs(setClearRespuestaPausaExcedida());
  };

  const handleBackendClearPausarTarea = async () => {
    await dispatchs(setBackendClearPausarTarea());
  };

  const handleBackendClearReiniciarTarea = async () => {
    await dispatchs(setBackendClearReiniciarTarea());
  };
  const handleBackendListaTareasRecurso = useCallback(
    async (Cantidad: number, NumPagina: number): Promise<void> => {
      await dispatchs(
        setBackendListaTareasRecurso("A Tomar", Cantidad, NumPagina),
      );
    },
    [dispatchs],
  );

  const handleBTareasTomadasRecurso = useCallback(
    async (Cantidad: number, NumPagina: number): Promise<void> => {
      await dispatchs(
        setBackendListaTareasTomadasRecurso("Tomadas", Cantidad, NumPagina),
      );
    },
    [dispatchs],
  );

  const handleBackendGuardias = useCallback(async (): Promise<void> => {
    await dispatchs(
      setBackendObtenerGuardia(
        "Pendiente",
        objUsuarioStore.IdPerfil,
        objUsuarioStore.UsuarioBackend,
      ),
    );
  }, [dispatchs]);

  const handleBackendGuardiasRealizadas =
    useCallback(async (): Promise<void> => {
      await dispatchs(
        setBackendObtenerGuardiaRealizada(
          "Realizada",
          objUsuarioStore.IdPerfil,
          objUsuarioStore.UsuarioBackend,
        ),
      );
    }, [dispatchs]);

  const handleBackendGuardiasCanceladas =
    useCallback(async (): Promise<void> => {
      await dispatchs(
        setBackendObtenerGuardiaCancelada(
          "Cancelada",
          objUsuarioStore.IdPerfil,
          objUsuarioStore.UsuarioBackend,
        ),
      );
    }, [dispatchs]);

  return {
    idTask,
    idCase,
    categoriaPorId,
    categoriaId,
    setCategoriaPorId,
    handleBackendClearCategoriaPorId,
    handleBackendClearPausarTarea,
    handleBackendClearReiniciarTarea,
    handleBTareasTomadasRecurso,
    handleCategoriaDescripcion,
    navigate,
    navigateTo,
    handleLimpiarStatus,
    redirectTask,
    redirectCase,
    refreshPage,
    handleBackendTareaTomarLiberar,
    handleBackendClearTareaResolver,
    handleBackendClearTareaTomarLiberar,
    handleBackendComentariosCasoActivo,
    handleBackendItemTareaCatalogo,
    handleBackendObtenerTiposPausa,
    handlePausaDiaria,
    handleBackendReiniciarTarea,
    handleBackendPausarTarea,
    handleClearRespuestaPausaExcedida,
    handleRespuestaPausaExcedida,
    handleBackendListaTareasRecurso,
    handleBackendGuardiasCanceladas,
    handleBackendGuardiasRealizadas,
    handleBackendGuardias,
    dispatchs,
    handeAddCommentBackend,
    handleBackendObtenerEstadoUsuario,
    handleBackendClearObtenerEstadoUsuario,
    handleDisponible,
  };
};
